<template>
  <div>
    <!-- <Breadcrumb :options="breadcrumb" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="200" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "VehicleHang",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'trailer',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
      ],
      formCtrl: [
        {
          label: "挂车号",
          keyName: "pname",
          placeholder: "请填写挂车号",
          type: "text",
        },
      ],
      cols: [
        { prop: "trailer", label: "挂车号" },
        { prop: "license", label: "车牌号" },
        { prop: "ton", label: "载货重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "buytime", label: "车辆购入时间" },
        // { prop: "carstatus", label: "状态" },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            this.$router.push(
              `/vehicle/hangview?id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/vehicle/hangdetail?mode=edit&id=${id}&fleetid=${this.formInline.fleet}&fleetName=${this.fleetName}`);
          },
        },
        {
          class: 'insurancebtn',
          img: require('@/assets/img/icon_insurance.png'),
          unimg: require('@/assets/img/icon_insurance_hover.png'),
          title: '保险',
          cb: ({ id, trailer}) => {
            this.$router.push(`/vehicle/insurance1?car_type=2&id=${id}&license=${trailer}`);
          },
        },
        {
          class: 'documentbtn',
          img: require('@/assets/img/icon_document.png'),
          unimg: require('@/assets/img/icon_document_hover.png'),
          title: '证件',
          cb: ({ id, trailer}) => {
            this.$router.push(`/vehicle/document1?car_type=2&id=${id}&license=${trailer}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      baseParams: ['carstatus'],
      list: ['在用', '停用', '报废'],
    };
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams()
    },
  },
  methods: {
    delParamsPackage(params) {
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'trailer',
      }

      // console.log('params', { ...params })
    },

    addItem() {
      this.$router.push(`/vehicle/hangdetail`);
    },
    setParams() {
      const { status } = this.$route.params
      this.formInline.carstatus = this.list[status - 1]
      this.getList()
    },
  },
  mounted() {
    this.setParams();
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>